import i18next from 'i18next'
import I18NextVue from 'i18next-vue'
import type { App } from 'vue'
import { CURRENT_LANGUAGE } from '@/utils/constants'
import { nl } from '@/locales/nl'

export const DEFAULT_I18N_NAMESPACE = 'common'

export async function initializeI18Next(app: App<Element>) {
  const defaultLanguage = localStorage.getItem(CURRENT_LANGUAGE) ?? 'nl'

  localStorage.setItem(CURRENT_LANGUAGE, defaultLanguage)

  await i18next.init({
    ns: [DEFAULT_I18N_NAMESPACE],
    defaultNS: DEFAULT_I18N_NAMESPACE,
    fallbackNS: DEFAULT_I18N_NAMESPACE,
    lng: defaultLanguage.toLowerCase(),
    fallbackLng: 'nl',
    resources: {
      nl: { [DEFAULT_I18N_NAMESPACE]: nl },
    },
  })

  app.use(I18NextVue, { i18next })
}
